import React from 'react';
import CompanyNavbar from './CompanyNavbar';
import CompanySidebar from './CompanySidebar';

export default function CompanyLayout({ children }) {
	return (
		<div className="min-h-screen bg-gray-50">
			<CompanyNavbar />
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-6 mt-6">
					<div className="hidden md:block">
						<CompanySidebar />
					</div>
					<main className="min-h-[60vh]">{children}</main>
				</div>
			</div>
		</div>
	);
}


